import path from "path-browserify";

export const joinPath = (...pathelements: string[]) => {
  return path.join(...pathelements);
};
